import axios, { CanceledError } from 'axios';
import log from 'lib/logger';
import { brandedId } from 'helpers/random-id';
import ApplicationController from './application_controller';

const openCardIds = new Set();
export default class extends ApplicationController {
  static targets = ['card'];
  static values = { url: String };
  connect() {
    this.element.id = brandedId();
  }

  disconnect() {
    this.#removeCardFromDOM();
    this.#removeCardFromQueue();
  }

  show() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    openCardIds.add(this.element.id);
    this.#closeOtherCards();
    if (this.hasCardTarget) {
      this.cardTarget.hidden = false;
    } else {
      this.#fetchCard(this.abortController.signal);
    }
  }

  hide() {
    this.#closeCard();
    this.#removeCardFromQueue();
  }

  async #fetchCard(signal) {
    try {
      const { data: html } = await axios.get(this.urlValue, {
        headers: {
          accept: 'text/fragment+html',
          credentials: 'same-origin',
          'X-AJAX-LOAD-ONLY': 'true',
        },
        signal,
      });
      const fragment = document.createRange().createContextualFragment(html);
      this.element.appendChild(fragment);
    } catch (error) {
      // Ignore if it is a CanceledError (aka AbortError)
      if (!(error instanceof CanceledError)) {
        log.error(error);
      }
    }
  }

  #closeOtherCards() {
    for (const id of openCardIds) {
      if (id !== this.element.id) {
        const cardElement = document.querySelector(`#${id} [data-${this.identifier}-target="card"]`);
        cardElement?.setAttribute('hidden', '');
        openCardIds.delete(id);
      }
    }
  }

  #closeCard() {
    if (this.hasCardTarget) {
      this.cardTarget.hidden = true;
    }
  }

  #removeCardFromDOM() {
    if (this.hasCardTarget) {
      this.cardTarget.remove();
    }
  }

  #removeCardFromQueue() {
    openCardIds.delete(this.element.id);
    this.abortController?.abort();
  }
}
